(() => {
  const page = document.querySelector('[data-snacc-page]');
  if (!page) return;
  const $ = (selector, context = page) => context.querySelector(selector);
  const $$ = (selector, context = page) => [...context.querySelectorAll(selector)];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = cents => '₹' + (Number(cents || 0) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  let toastTimer;
  const toast = message => {
    const box = $('[data-snacc-toast]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { box.hidden = true; }, 3500);
  };
  const refreshCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    $$('[data-snacc-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart,source:'snacc-drawer'}}));
    const bag = $('.snacc-header__bag');
    if (bag) bag.setAttribute('aria-label', `Your snacc bag, ${cart.item_count} items`);
  };
  const addItems = async (items, button) => {
    if (!items.length) return;
    if (button) button.disabled = true;
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add to bag.');
      await refreshCart(); // the "In the bag!" banner comes from assets/snacc-cart-drawer.js
    } catch (error) { toast(error.message || 'Could not add to bag. Please try again.'); }
    finally { if (button) button.disabled = false; }
  };

  const menuButton = $('[data-snacc-menu-toggle]');
  const menu = $('[data-snacc-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      menu.hidden = !open;
    });
    $$('a', menu).forEach(link => link.addEventListener('click', () => {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
    }));
  }

  $$('[data-snacc-add]').forEach(button => button.addEventListener('click', () => {
    const id = Number(button.dataset.snaccAdd);
    if (id) addItems([{ id, quantity: 1 }], button);
  }));

  if (page.dataset.snaccPage === 'home') {
    const slides = $$('[data-snacc-slide]');
    const dots = $$('[data-snacc-hero-dot]');
    let current = 0;
    let timer;
    const showSlide = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', String(i !== current)); });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-pressed', String(i === current)); });
    };
    const resetTimer = () => { clearInterval(timer); timer = setInterval(() => showSlide(current + 1), 5000); };
    if (slides.length) {
      dots.forEach((dot, i) => dot.addEventListener('click', () => { showSlide(i); resetTimer(); }));
      $('[data-snacc-hero-next]')?.addEventListener('click', () => { showSlide(current + 1); resetTimer(); });
      const hero = $('[data-snacc-hero]');
      let touchX;
      hero?.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, { passive: true });
      hero?.addEventListener('touchend', event => { if (touchX == null) return; const dx = event.changedTouches[0].clientX - touchX; if (Math.abs(dx) > 40) { showSlide(current + (dx < 0 ? 1 : -1)); resetTimer(); } touchX = null; }, { passive: true });
      showSlide(0);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) resetTimer();
    }

    const finderDataEl = $('[data-snacc-finder-products]');
    if (finderDataEl) {
      try {
        const data = JSON.parse(finderDataEl.textContent);
        let category = 'makhana';
        let mood = 0;
        const match = $('[data-snacc-match]');
        const update = () => {
          const item = data[category]?.[mood];
          if (!item || !match) return;
          $('[data-snacc-match-category]').textContent = category === 'makhana' ? 'Makhana' : category === 'minis' ? '₹10 minis' : 'Dry fruits';
          $('[data-snacc-match-name]').textContent = item.name;
          $('[data-snacc-match-meta]').textContent = ['Smoky', 'Spicy', 'Classic', 'Herby', 'Minty'][mood] + ' · roasted';
          $('[data-snacc-match-line]').textContent = item.line;
          $('[data-snacc-match-price]').textContent = item.price;
          $('[data-snacc-match-link]').href = item.url;
          const image = $('[data-snacc-match-image]'); image.src = item.image; image.alt = item.name;
          $('.snacc-finder__match-main').style.background = item.tint;
          $('.snacc-finder__match-bottom').style.background = item.accent;
        };
        $$('[data-snacc-finder-tab]').forEach(button => button.addEventListener('click', () => {
          category = button.dataset.snaccFinderTab;
          $$('[data-snacc-finder-tab]').forEach(node => node.classList.toggle('is-active', node === button));
          update();
        }));
        $$('[data-snacc-mood]').forEach(button => button.addEventListener('click', () => {
          mood = Number(button.dataset.snaccMood);
          $$('[data-snacc-mood]').forEach(node => node.classList.toggle('is-active', node === button));
          update();
        }));
      } catch (error) { console.warn('Snacc finder data could not load', error); }
    }

    $$('[data-snacc-filter]').forEach(button => button.addEventListener('click', () => {
      const filter = button.dataset.snaccFilter;
      $$('[data-snacc-filter]').forEach(node => node.classList.toggle('is-active', node === button));
      $$('[data-snacc-card-category]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.snaccCardCategory !== filter; });
    }));
    $('[data-snacc-flip]')?.addEventListener('click', () => $('[data-snacc-flip-card]')?.classList.toggle('is-flipped'));
    $('[data-snacc-flip-card]')?.addEventListener('click', () => $('[data-snacc-flip-card]')?.classList.toggle('is-flipped'));

    const bundleRows = $$('[data-snacc-bundle-row]');
    const updateBundle = () => {
      let count = 0, total = 0;
      bundleRows.forEach(row => {
        const quantity = Number($('output', row).textContent);
        count += quantity; total += quantity * Number(row.dataset.price || 0);
      });
      $('[data-snacc-bundle-count]').textContent = count;
      $('[data-snacc-bundle-total]').textContent = money(total);
      const addButton = $('[data-snacc-bundle-add]');
      addButton.disabled = count === 0;
      addButton.textContent = count ? `Pack my box · ${count} →` : 'Pick a flavour first →';
    };
    bundleRows.forEach(row => $$('[data-step]', row).forEach(button => button.addEventListener('click', () => {
      const output = $('output', row);
      output.textContent = Math.min(9, Math.max(0, Number(output.textContent) + Number(button.dataset.step)));
      updateBundle();
    })));
    $('[data-snacc-bundle-add]')?.addEventListener('click', event => {
      const items = bundleRows.map(row => ({ id: Number(row.dataset.variantId), quantity: Number($('output', row).textContent) })).filter(item => item.id && item.quantity);
      addItems(items, event.currentTarget);
    });
  }

  if (page.dataset.snaccPage === 'pdp') {
    const gallerySlides = $$('.snacc-gallery__slide');
    const galleryTabs = $$('[data-snacc-gallery-tab]');
    const showImage = index => {
      gallerySlides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      galleryTabs.forEach(tab => tab.classList.toggle('is-active', Number(tab.dataset.snaccGalleryTab) === index));
    };
    galleryTabs.forEach(tab => tab.addEventListener('click', () => showImage(Number(tab.dataset.snaccGalleryTab))));
    let galleryX;
    $('.snacc-gallery__stage')?.addEventListener('touchstart', event => { galleryX = event.touches[0].clientX; }, { passive: true });
    $('.snacc-gallery__stage')?.addEventListener('touchend', event => { if (galleryX == null) return; const dx = event.changedTouches[0].clientX - galleryX; if (Math.abs(dx) > 40) { const active = gallerySlides.findIndex(slide => slide.classList.contains('is-active')); showImage((active + (dx < 0 ? 1 : -1) + gallerySlides.length) % gallerySlides.length); } galleryX = null; }, { passive: true });

    const form = $('#snacc-product-form');
    const quantityInput = $('[data-snacc-qty]');
    const variantInput = $('[data-snacc-variant-input]');
    let selectedPrice = Number($('[data-snacc-variant].is-active')?.dataset.price || 0);
    if (!selectedPrice) {
      const initialText = $('[data-snacc-price]')?.textContent || '';
      selectedPrice = Number(initialText.replace(/[^0-9.]/g, '')) * 100;
    }
    let selectedCompare = Number($('[data-snacc-variant].is-active')?.dataset.compare || 0);
    const updatePrice = () => {
      const qty = Math.max(1, Number(quantityInput?.value || 1));
      if (quantityInput) quantityInput.value = qty;
      const total = selectedPrice * qty;
      $('[data-snacc-price]').textContent = money(total);
      $('[data-snacc-add-price]').textContent = money(total);
      $('[data-snacc-sticky-price]').textContent = money(total);
      const compare = $('[data-snacc-compare]');
      if (compare) { compare.hidden = !selectedCompare || selectedCompare <= selectedPrice; if (!compare.hidden) compare.textContent = money(selectedCompare * qty); }
      const fill = $('[data-snacc-shipping-fill]'); if (fill) fill.style.width = Math.min(100, total / 64900 * 100) + '%';
    };
    $$('[data-snacc-variant]').forEach(button => button.addEventListener('click', () => {
      variantInput.value = button.dataset.snaccVariant;
      selectedPrice = Number(button.dataset.price);
      selectedCompare = Number(button.dataset.compare);
      $$('[data-snacc-variant]').forEach(node => node.classList.toggle('is-active', node === button));
      updatePrice();
    }));
    $$('[data-snacc-qty-step]').forEach(button => button.addEventListener('click', () => {
      quantityInput.value = Math.min(99, Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.snaccQtyStep)));
      updatePrice();
    }));
    quantityInput?.addEventListener('change', updatePrice);
    const addMain = () => addItems([{ id: Number(variantInput.value), quantity: Math.max(1, Number(quantityInput.value || 1)) }], $('.snacc-buy__add'));
    $('.snacc-buy__add')?.addEventListener('click', addMain);
    $('[data-snacc-sticky-add]')?.addEventListener('click', addMain);
    const buy = $('#snacc-buy');
    const sticky = $('.snacc-pdp__sticky');
    if (buy && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => sticky.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold: 0 });
      observer.observe(buy);
    }
  }
})();
